import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSeo from "@/lib/useSeo";
import { GUIDES } from "@/lib/content";

export default function StyleGuide() {
  const { slug } = useParams();
  const g = GUIDES.find((x) => x.slug === slug);
  useSeo(g?.title, g?.desc);
  if (!g) return <Navigate to="/" replace />;
  return (
    <article data-testid="style-guide-page" className="kt-container max-w-4xl py-12 sm:py-16">
      <Link to="/" className="flex items-center gap-2 text-sm text-[#B85D43]"><ArrowLeft className="h-4 w-4" /> Back to Kurtaani</Link>
      <p className="eyebrow mt-8">The style journal</p>
      <h1 className="mt-3 font-serif-display text-5xl font-semibold leading-tight sm:text-6xl">{g.title}</h1>
      <p className="mt-4 text-lg text-[#57534E]">{g.desc}</p>
      <img src={g.img.replace("w=1000", "w=1400")} alt={g.title} className="mt-10 aspect-[16/10] w-full rounded-3xl object-cover object-top" />
      <div className="mt-10 space-y-5 text-base leading-relaxed text-[#44403C]">{g.body.map((b, i) => <p key={i}><span className="mr-3 font-serif-display text-2xl text-[#B85D43]">0{i + 1}</span>{b}</p>)}</div>
      <Link to="/collections/all" className="btn-primary mt-10">Shop the Look</Link>
    </article>
  );
}
